import styled from 'styled-components';

import { FaqSection } from '../../_molecules/FaqSection';
import { NextPageWithLayout } from '../../layouts';

const Container = styled.div`
  width: 100%;
`;

const QuotesPageContent: NextPageWithLayout = () => {
  return (
    <Container style={{ marginTop: 40 }}>
      <FaqSection variant="green" />
    </Container>
  );
};

export default QuotesPageContent;
